import React, { useState, useEffect } from "react";
import "../assets/css/comparecolleges.css";
import Footer from "./footer";
import { useNavigate, useLocation } from "react-router-dom";
import { FaAngleRight } from "react-icons/fa";
import { MutatingDots } from "react-loader-spinner";

function CompareColleges() {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const pathname = window.location.pathname;

    const basePath = pathname.split('/').slice(0, 2).join('/');

    const currentUrl = `${window.location.origin}${basePath}`;
    
    const { img_1, img_2 } = location.state || {};

    const img_1_namesArray = Array.isArray(img_1?.facilities) ? img_1?.facilities : JSON.parse(img_1?.facilities);

    const img_1_facilities_data = img_1_namesArray?.map((item) => ({
        name: item?.name,
        path: item?.path || null
    }));

    const img_2_namesArray = Array.isArray(img_2?.facilities) ? img_2?.facilities : JSON.parse(img_2?.facilities);

    const img_2_facilities_data = img_2_namesArray?.map((item) => ({
        name: item?.name,
        path: item?.path || null || null
    }));

    function decodeHTML(html) {
        const txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    };

    useEffect(() => {
        setLoading(true);

        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="mainnav-container flex-column h-auto">
            {loading && (
                <div className="loader">
                    <MutatingDots
                        height="100"
                        width="100"
                        color="#35e2e9"
                        secondaryColor="#FF9800"
                        radius="15"
                        ariaLabel="mutating-dots-loading"
                        visible={true}
                    />
                </div>
            )}
            <div className="d-flex justify-content-between align-items-center w-100" style={{ padding: "0px 10px" }}>
                <h2 className="cmp_title mb-0">COMPARISON RESULT</h2>
                <p className="cmp_titlenav" > <span className="gotohome-st hovrchnge-st" onClick={() => navigate("/")} >Home</span> <FaAngleRight className="arrow_icon" /> <span className="gotohome-st hovrchnge-st" onClick={() => navigate("/college_listing")} >Colleges</span> <FaAngleRight className="arrow_icon" /> Comparecolleges</p>
            </div>

            <div className="cmp_table-main">
                <div className="cmp_table">
                    <div className="cmp_row cmp_header">
                        <div className="d-center text-uppercase text-center text-primary-st">College</div>
                        <div className="d-center flex-column text-uppercase text-center text-primary-st">
                            <img src={img_1?.college_logo} alt="college_logo" className="logoclocompst" />
                            {img_1?.name}
                        </div>
                        <div className="d-center flex-column text-uppercase text-center text-primary-st">
                            <img src={img_2?.college_logo} alt="college_logo" className="logoclocompst" />
                            {img_2?.name}
                        </div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Country</div>
                        <div>{img_1?.country}</div>
                        <div>{img_2?.country}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">State</div>
                        <div>{img_1?.state}</div>
                        <div>{img_2?.state}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">City</div>
                        <div>{img_1?.city}</div>
                        <div>{img_2?.city}</div>
                    </div>

                    <div className="cmp_section text-primary-st">GENERIC DETAILS</div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Established On</div>
                        <div>{img_1?.established}</div>
                        <div>{img_2?.established}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Approved By</div>
                        <div>{img_1?.approved_by}</div>
                        <div>{img_2?.approved_by}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Affiliated To</div>
                        <div>{img_1?.affiliated_to}</div>
                        <div>{img_2?.affiliated_to}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">University</div>
                        <div>{img_1?.university}</div>
                        <div>{img_2?.university}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Campus area</div>
                        <div>{img_1?.campus_area}</div>
                        <div>{img_2?.campus_area}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Management</div>
                        <div>{img_1?.management}</div>
                        <div>{img_2?.management}</div>
                    </div>
                    <div className="cmp_row">
                        <div className="text-primary-st">Faculty ratio</div>
                        <div>{img_1?.faculty_ratio}</div>
                        <div>{img_2?.faculty_ratio}</div>
                    </div>

                    <div className="cmp_section text-primary-st">LOCATION DETAILS</div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Address</div>
                        <div
                            dangerouslySetInnerHTML={{
                                __html: decodeHTML(img_1?.address || "")
                            }}
                        />

                        <div
                            dangerouslySetInnerHTML={{
                                __html: decodeHTML(img_2?.address || "")
                            }}
                        />
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Near by Bus Stand</div>
                        <div>{img_1?.near_by_busstand}</div>
                        <div>{img_2?.near_by_busstand}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Near by Railway Station</div>
                        <div>{img_1?.near_by_railwaystation}</div>
                        <div>{img_2?.near_by_railwaystation}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Near by Airport</div>
                        <div>{img_1?.near_by_airport}</div>
                        <div>{img_2?.near_by_airport}</div>
                    </div>

                    <div className="cmp_section text-primary-st">OTHER INFORMATION</div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Facilities</div>
                        <div className="facilities-divst">
                            {img_1_facilities_data?.map((item, idx) => (
                                <span key={idx} className="facilities-st" >
                                    <p className="text-center mb-2 fw-bold w-100 font-small">{item.name}</p>
                                    <img src={currentUrl  + item.path} alt="img_path" style={{ width: "42px" }} />
                                </span>

                            ))}
                        </div>
                        <div className="facilities-divst">
                            {img_2_facilities_data?.map((item, idx) => (
                                <span key={idx} className="facilities-st" >
                                    <p className="text-center mb-2 fw-bold w-100 font-small">{item.name}</p>
                                    <img src={currentUrl + item.path} alt="img_path" style={{ width: "42px" }} />
                                </span>
                            ))}
                        </div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Average salary</div>
                        <div>{img_1?.avearge_salary}</div>
                        <div>{img_2?.avearge_salary}</div>
                    </div>

                    <div className="cmp_row">
                        <div className="text-primary-st">Highest salary</div>
                        <div>{img_1?.highest_salary}</div>
                        <div>{img_2?.highest_salary}</div>
                    </div>
                </div>
            </div>

            {!loading && (
                <Footer />
            )}
        </div>
    );
}

export default CompareColleges;